import React from 'react'

const Manual_solicitar_uber_direct_invu = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold text-4xl text-[#002D33] mb-5">
          Solicitar Uber Direct (creando orden desde Invu POS)
        </h2>
        <iframe
          src="https://scribehow.com/embed/Solicitar_Uber_Direct_creando_orden_desde_Invu_POS__SRbPtxXtTPy-qDEhahWcnQ?as=scrollable"
          className="scribe-iframe-general-73"
          width="100%"
          height="6200"
          allow="fullscreen"
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_solicitar_uber_direct_invu
